/**
 * Auth/session diagnostics — enable with REACT_APP_AUTH_SESSION_DEBUG=true
 * or window.__PT_AUTH_DEBUG__ = true in the browser console.
 */
const isEnabled = () => {
  if (typeof window !== "undefined" && window.__PT_AUTH_DEBUG__) return true;
  return process.env.REACT_APP_AUTH_SESSION_DEBUG === "true";
};

export function logAuthSession(event, detail = {}) {
  const payload = { ts: new Date().toISOString(), ...detail };
  if (isEnabled()) {
    console.info("[AuthSession]", event, payload);
    return;
  }
  // Always surface forced-logout signals in prod (no PII — reasons/URLs only).
  if (event === "forced_logout" || event === "forced_logout_suppressed") {
    console.warn("[AuthSession]", event, payload);
  }
}
